// extracted by mini-css-extract-plugin
export default {"shippingReport":"ShippingReport_shippingReport__lk-8V"};